import * as React from "react";
const SvgFiRrMelonAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-melon-alt_svg__a)">
      <path
        fill="#062147"
        d="M21.02 2.98C16.653-1.38 9.06-.885 4.086 4.088-.885 9.06-1.381 16.656 2.981 21.019c1.995 1.995 4.665 2.974 7.451 2.974 3.308 0 6.78-1.38 9.48-4.08 2.39-2.39 3.83-5.453 4.057-8.624.23-3.225-.817-6.175-2.95-8.308m-2.078 4.654c-2.078 4.157-7.15 9.229-11.307 11.307-2.056 1.029-3.019.884-3.239.663-.221-.22-.366-1.181.663-3.24 2.078-4.156 7.15-9.228 11.307-11.306 1.266-.633 2.116-.822 2.635-.822.325 0 .52.074.604.159.221.22.366 1.182-.663 3.239M5.502 5.5c3.287-3.286 7.881-4.29 11.441-2.85-.452.158-.93.348-1.472.618-4.485 2.243-9.958 7.716-12.201 12.2-.271.542-.46 1.02-.617 1.473-1.441-3.56-.438-8.154 2.849-11.441m16.473 5.646c-.19 2.69-1.427 5.302-3.477 7.352-3.288 3.287-7.88 4.29-11.44 2.849a12 12 0 0 0 1.471-.617c4.484-2.242 9.958-7.715 12.201-12.201.272-.543.462-1.024.62-1.477.504 1.242.73 2.629.624 4.095z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-melon-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMelonAlt;
